'use client';
import { ImageRenderer } from '~shared/ui/molecules';

import type { TBotConfig } from '../../../types';
import { Icon } from './styles';

type Props = {
	images: TBotConfig['images'];
};

export const BotHeaderAvatar = ({ images }: Props) => (
	<ImageRenderer
		width={28}
		height={28}
		alt="icon"
		className={Icon}
		item={images.chatAvatarLinks}
		fallback={images.chatAvatarPath!}
	/>
);
